import { render, staticRenderFns } from "./Ca.vue?vue&type=template&id=20eac712&scoped=true&"
import script from "./Ca.vue?vue&type=script&lang=js&"
export * from "./Ca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eac712",
  null
  
)

export default component.exports